import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {PageService} from '../services/page.service';

@Injectable({
  providedIn: 'root'
})
export class PageInitialiseeGuard implements CanActivate {
  constructor(
    public pageServ: PageService
  ) {
  
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
    return this.pageServ.pageInitReplaySubject.asObservable();
  }
  
}
